export default __webpack_public_path__ + "static/media/KateTerlecka_BrassWillow_recommend.97518099.jpg";